import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

import type { Publication } from '~/interfaces/publication';

import LoginModal from '../Layout/Nav/LoginModal';
import SubscribeSlideUpModal from '../Modal/SubscribeLoginSlideUpModal';
import Signup from '../Signup';
import type { SignupStyles } from '../Signup/types';
import useGlobalModals from './hooks/useGlobalModals';

interface Props {
  publication: Publication;
  signupWidgetConfigs: SignupStyles;
}

const GlobalModals = ({ publication, signupWidgetConfigs }: Props) => {
  const { isLoginModalOpen, isSignupModalOpen, handleCloseModal } = useGlobalModals();

  const { t } = useTranslation();

  return (
    <div>
      {/** LOG IN */}
      {isLoginModalOpen && (
        <LoginModal isOpen={isLoginModalOpen} handleCloseModal={handleCloseModal} publication={publication} />
      )}

      {isSignupModalOpen && (
        <SubscribeSlideUpModal
          title={`${t('subscribe.modal_header')} ${publication?.name || ''}`}
          description={publication?.description || ''}
          publication={publication}
          isOpen={isSignupModalOpen}
          onClose={handleCloseModal}
          alternativeAction={
            <>
              <span className="opacity-75">{t('login.already_a_subscriber')} </span>
              <Link to="/login" className="inline-flex justify-center underline">
                {t('meta.titles.login')}
              </Link>
            </>
          }
        >
          <Signup signupStyles={signupWidgetConfigs} />
        </SubscribeSlideUpModal>
      )}
    </div>
  );
};

export default GlobalModals;
